// Floating Tactical Toast Notifications

export type ToastType = 'success' | 'info' | 'warning' | 'mayday' | 'error';

export function showToast(message: string, type: ToastType = 'success'): void {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const toast = document.createElement('div');
  
  let borderClass = 'border-cyan-400 bg-[#0a0c13] text-cyan-200 shadow-[0_0_15px_rgba(0,240,255,0.25)]';
  let icon = 'fa-check-circle text-cyan-400';
  
  if (type === 'info') {
    borderClass = 'border-purple-400 bg-[#0a0c13] text-purple-200 shadow-[0_0_15px_rgba(192,132,252,0.25)]';
    icon = 'fa-info-circle text-purple-400';
  } else if (type === 'warning') {
    borderClass = 'border-amber-400 bg-[#0a0c13] text-amber-200 shadow-[0_0_15px_rgba(255,183,3,0.25)]';
    icon = 'fa-triangle-exclamation text-amber-400';
  } else if (type === 'mayday') {
    borderClass = 'border-pink-500 bg-[#0a0c13] text-pink-200 shadow-[0_0_20px_rgba(255,42,133,0.3)]';
    icon = 'fa-satellite-dish text-pink-400 animate-pulse';
  } else if (type === 'error') {
    borderClass = 'border-red-500 bg-[#0a0c13] text-red-200 shadow-[0_0_15px_rgba(239,68,68,0.25)]';
    icon = 'fa-circle-xmark text-red-400';
  }

  toast.className = `flex items-center gap-3 p-3.5 rounded-xl border shadow-xl text-xs font-semibold transform transition-all duration-300 translate-y-2 opacity-0 pointer-events-auto ${borderClass}`;
  toast.innerHTML = `
    <i class="fa-solid ${icon} text-base flex-shrink-0"></i>
    <span class="flex-1">${message}</span>
    <button class="toast-close-btn text-slate-400 hover:text-white ml-2 p-1">
      <i class="fa-solid fa-xmark"></i>
    </button>
  `;

  const closeBtn = toast.querySelector('.toast-close-btn');
  closeBtn?.addEventListener('click', () => {
    toast.classList.add('opacity-0', 'translate-y-2');
    setTimeout(() => toast.remove(), 250);
  });

  container.appendChild(toast);

  // Animate entry
  requestAnimationFrame(() => {
    toast.classList.remove('translate-y-2', 'opacity-0');
  });

  // Auto remove after 4.5s
  setTimeout(() => {
    if (toast.parentElement) {
      toast.classList.add('opacity-0', 'translate-y-2');
      setTimeout(() => toast.remove(), 250);
    }
  }, 4500);
}
